import { gql } from '@apollo/client';

export const GENERATE_AICS_CARD = gql`
    mutation generateAICSCard($id: String!) {
        generateAICSCard(id: $id) {
            id
            aics_member_code
            aics_card_number
            aics_card_issued_at
            aics_card_expires_at
            fiscal_code
            birth_city
            birth_province
        }
    }
`;

export const GENERATE_AICS_CARDS = gql`
    mutation generateAICSCards($ids: [String]!) {
        generateAICSCards(ids: $ids) {
            success
            fail
            fail_reasons
        }
    }
`;
